import { Directive, input, output } from '@angular/core';

import { DocumentViewSection } from '../../../../../../providers/nlp-output.service';
import { SectionFilter } from '../document-view.component';

@Directive()
export abstract class BaseSectionComponent {
  section = input<DocumentViewSection>();
  sectionFilter = input<SectionFilter>();
  isPlaybackDisabled = input<boolean>();

  toggleSection = output<DocumentViewSection>();
  toggleSectionLabel = output<DocumentViewSection>();
  toggleAudioPlayer = output<DocumentViewSection>();

  onSectionClicked() {
    this.toggleSection.emit(this.section());
  }

  onSectionLabelClicked($event) {
    $event.preventDefault();
    $event.stopPropagation();
    this.toggleSectionLabel.emit(this.section());
  }

  onSectionTextClicked() {
    this.toggleAudioPlayer.emit(this.section());
  }
}
